<template>
  <div class="data-grid-container" :style="styles">
    <div
      class="data-grid-element"
      v-for="header in headers.filter((x) => x.hide !== true)"
      :key="header.value || Math.random()"
      :style="gridColumns(header) + getBackground(header) + getColor(header)"
    >
      <div class="label">{{ header.label }}</div>
      <div class="value">
        {{ valueFormat(header) }}
      </div>
    </div>
  </div>
</template>

<script>
    import moment from "moment";
    import { UrlBundles, UserInfo } from "Libs/core";
    moment.suppressDeprecationWarnings = true;
    export default {
        data() {
            return {
                urlBundles: UrlBundles,
                userInfo: UserInfo,
                moment: moment,
            };
        },
        props: {
            headers: {
                type: Array,
                default: [],
            },
            item: {
                type: Object,
                default: {},
            },
            columns: {
                type: Number,
                default: 1,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            search: {
                type: String,
                default: "",
            },
            styles: {
                type: String,
                default: "",
            },
            colorLight: {
                type: String,
                default: "rgba(0,0,0,.87)",
            },
            colorDark: {
                type: String,
                default: "",
            },
            backgroundLight: {
                type: String,
                default: "#f0f0f0",
            },
            backgroundDark: {
                type: String,
                default: "#393939",
            },
        },
        computed: {
            headersMap() {
                return this.headers.reduce(
                    (map, obj) => ((map[obj.value] = obj), map),
                    {}
                );
            },
        },
        methods: {
            getBackground({ background }) {
                return background
                    ? "background-color:" + background + ";"
                    : this.$vuetify.theme.dark
                        ? "background-color:" + this.backgroundDark + ";"
                        : "background-color:" + this.backgroundLight + ";";
            },
            getColor({ color }) {
                return color ? "color:" + color + ";"
                    : this.$vuetify.theme.dark
                        ? "" : "color:" + this.colorLight + ";";
            },
            gridColumns({ colSpan }) {
                let width = colSpan ? (100 / this.columns) * colSpan : 100 / this.columns;
                this.$vuetify.breakpoint.mobile ? (width = 100) : width;
                return "width: " + width + "%;";
            },
            valueFormat({ type, value, format = this.$t("dateFormat.dateTime") }) {
                switch (type) {
                    case Date:
                        return moment
                            .utc(value.split(".").reduce((o, i) => o[i] || "-", this.item))
                            .format(format);
                        break;
                    case Function:
                        return this.headersMap[value].valueFormatter(this.item) || "";
                        break;
                    default:
                        return (
                            value.split(".").reduce((o, i) => o[i] || "-", this.item) || "-"
                        );
                }
                // return type === Date
                //   ? moment
                //       .utc(value.split(".").reduce((o, i) => o[i] || "-", this.item))
                //       .format(format)
                //   : value.split(".").reduce((o, i) => o[i] || "-", this.item) || "-";
            },
        },
        mounted() { },
    };
</script>

<style lang="scss">
    .fill-height {
        height: 100%;
    }

    .data-grid-container {
        display: flex !important;
        flex-wrap: wrap;
        flex-direction: row;
        padding: 16px 0;

        .data-grid-element {
            display: flex;
            flex-direction: column;
            font-size: 0.8rem;
            padding: 5px;
            border: 1px solid rgba(0,0,0,.12);

            .label {
                font-weight: bold;
                line-height: 1rem;
                word-break: break-word;
            }

            .value {
                line-height: 1rem;
                word-break: break-word;
            }
        }
    }
</style>